
export class AppError {
    constructor (public originalError? : any) {}
}


// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/_shared/services/app-error.ts